import React from 'react';
import { Grid } from '@mui/material';
import AssetsPresenter from './AssetsPresenter';
import Shell from '../../../common/components/Shell/Shell';
import { useTranslation } from 'react-i18next';
const AssetsController = () => {
  const { t, i18n } = useTranslation();

  return (
    <Shell>
      <Grid
        container
        style={{
          maxWidth: 'auto',
          marginLeft: i18n.language == 'en' ? '7.25em' : '',
        }}
      >
        <AssetsPresenter trans={t} i18n={i18n} />
      </Grid>
    </Shell>
  );
};
export default AssetsController;
